import { z } from 'zod';
/**
 * A phone's push token (design §11), sent after signing in and whenever the token or the phone's
 * Do Not Disturb changes. Signing out of that session stops its notifications.
 */
export const RegisterDeviceRequest = z.object({
    platform: z.enum(['ios', 'android']),
    token: z.string().min(16).max(4096),
    /** iOS: which APNs servers this build talks to ('development' for builds made with Xcode). */
    apnsEnvironment: z.enum(['development', 'production']).optional(),
    /** This phone's Do Not Disturb: it gets no notifications while it is on. */
    doNotDisturb: z.boolean().default(false),
});
/** Turns notifications off for one phone (its setting) without signing out. */
export const RemoveDeviceRequest = z.object({ token: z.string().min(16).max(4096) });
//# sourceMappingURL=devices.js.map